<div class="header_inner">
    <h1 class="header_logo">
        <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
    </h1>
    <div class="util_menu" *ngIf="!user.isAdmin">
        <button type="button" (click)="openMypageCommonPopup('gradeInfo')" class="util_user">{{user.userName}}({{user.userId}}) <span class="btn_grade {{user.userGrade === 'G2' ? 'btn-grade2' : 'btn-grade1'}}">{{user.userGradeName}}</span></button>
    </div>
    <span class="util_admin" *ngIf="user.isAdmin" style="display:none">
        <span class="util_admin_badge">관리자</span> {{user.userName}}({{user.userId}})
    </span>
    <span class="util_right">
        <button *ngIf="!user.isAdmin" type="button" (click)="openGuideWindow()" class="btn_box">이용가이드</button>
        <a routerLink="/mypage/main" class="btn_mypage" *ngIf="!user.isAdmin"><b>MY page</b></a>
        <a class="btn_logout" (click)="logout()"><b>LOGOUT</b></a>
    </span>
</div>
